import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

export const TableLoader = memo(function TableLoader({
  rows = 5,
  columns = 4,
  animated = true,
  width = "100%",
  height,
  className,
}: LoaderCommonProps) {
  const safeRows = Math.max(1, rows);
  const safeColumns = Math.max(1, columns);

  return (
    <div
      className={className}
      style={{
        width,
        height,
        overflowX: "auto",
        background: "#fff",
        borderRadius: tokens.radius,
        boxShadow: tokens.shadow,
        border: "1px solid #f0f0f0",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${safeColumns}, minmax(80px, 1fr))`,
          gap: tokens.spacing.sm,
          padding: tokens.spacing.md,
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        {Array.from({ length: safeColumns }).map((_, i) => (
          <Skeleton key={`header-${i}`} width="80%" height={16} animated={animated} />
        ))}
      </div>
      {Array.from({ length: safeRows }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${safeColumns}, minmax(80px, 1fr))`,
            gap: tokens.spacing.sm,
            padding: tokens.spacing.md,
            borderBottom: rowIndex < safeRows - 1 ? "1px solid #f5f5f5" : undefined,
          }}
        >
          {Array.from({ length: safeColumns }).map((_, colIndex) => (
            <Skeleton
              key={`cell-${rowIndex}-${colIndex}`}
              width={colIndex === 0 ? "90%" : "70%"}
              height={14}
              animated={animated}
            />
          ))}
        </div>
      ))}
    </div>
  );
});
